import { XHRRequestCanceler } from '../../Libs/xhr/XHRRequestCanceler';
import { BaseApiDataResponse } from '../Models/ApiData';
import { CompagnonListResponse } from '../Models/Compagnon/Compagnon';
import {
    CompagnonQualificationListResponse,
    SetCompagnonQualification,
    UpdateCompagnonQualificationParameters,
} from '../Models/Qualifications/Qualification';
import { BaseDataService } from './Base/BaseDataService';

export const CompagnonQualificationsEndpoints = {
    GET_COMPAGNON_QUALIFICATIONS_LIST: (compagnonId: string) =>
        `/api/v1/back/compagnons/${compagnonId}/qualifications`,
    UPDATE_COMPAGNON_QUALIFICATION: (compagnonId: string) =>
        `/api/v1/back/compagnons/${compagnonId}/qualifications`,
};

export interface IQualificationDataService {
    getCompagnonQualifications: (
        compagnonId: string,
        cts: XHRRequestCanceler
    ) => Promise<CompagnonQualificationListResponse>;

    updateCompagnonQualifications: (
        compagnonId: string,
        qualifications: UpdateCompagnonQualificationParameters,
        cts: XHRRequestCanceler
    ) => Promise<CompagnonQualificationListResponse>;
}

class QualificationDataService extends BaseDataService implements IQualificationDataService {
    getCompagnonQualifications = async (compagnonId: string, cts: XHRRequestCanceler) => {
        return this.get<CompagnonQualificationListResponse>(
            CompagnonQualificationsEndpoints.GET_COMPAGNON_QUALIFICATIONS_LIST(compagnonId),
            cts
        );
    };

    updateCompagnonQualifications = async (
        compagnonId: string,
        qualifications: UpdateCompagnonQualificationParameters,
        cts: XHRRequestCanceler
    ) => {
        const body = {
            ...qualifications,
        };
        return this.post<CompagnonQualificationListResponse>(
            CompagnonQualificationsEndpoints.UPDATE_COMPAGNON_QUALIFICATION(compagnonId),
            body,
            cts
        );
    };
}

const QualificationDataServiceName = 'QualificationDataService';
export { QualificationDataService, QualificationDataServiceName };
